var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "alarmCont" }, [
    _c("div", { staticClass: "listheader" }, [
      _c("div", { staticClass: "titleName" }, [_vm._v("疑似飞房")]),
      _c("span", [_vm._v("合计：" + _vm._s(_vm.numTotal))]),
    ]),
    _c("div", { staticClass: "alarm_panel" }, [
      _vm.sos
        ? _c(
            "div",
            { staticClass: "listcount" },
            [
              _vm.offlineStores.length
                ? _vm._l(_vm.offlineStores, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "list listHover" },
                      [
                        _c("div", { staticClass: "hotelName" }, [
                          _vm._v(_vm._s(_vm.showName(item.hname))),
                        ]),
                        _c("span", { staticClass: "Num" }, [
                          _vm._v(_vm._s(item.ffCnt)),
                        ]),
                      ]
                    )
                  })
                : [
                    _c(
                      "div",
                      { staticClass: "noData flex flex-center align-center" },
                      [_vm._v("\n          暂无 疑似飞房 数据\n        ")]
                    ),
                  ],
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "storesDetails", on: { click: _vm.showAll } },
            [
              _vm.offlineName
                ? _c("div", { staticClass: "storesName" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.showName(_vm.offlineName)) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "detailsListCont" }, [
                !_vm.showDataFlag
                  ? _c(
                      "div",
                      _vm._l(_vm.roomList, function (item, index) {
                        return _c("div", { key: index }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.floorName) +
                              _vm._s(item.roomNumber) +
                              "\n            房\n          "
                          ),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                !_vm.roomList || _vm.roomList.length == 0
                  ? _c(
                      "div",
                      { staticClass: "noData2 flex flex-center align-center" },
                      [_vm._v("\n          暂无 疑似飞房 数据\n        ")]
                    )
                  : _vm._e(),
              ]),
            ]
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }